import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const UnidadeContext = createContext(null);
const STORAGE_KEY = "coomflona_unidade";

export const UNIDADES_FALLBACK = [
  { id: "km117", nome: "KM 117 Anambé" },
  { id: "cupari", nome: "Rio Cuparí" },
  { id: "serraria", nome: "Serraria" },
];

export function UnidadeProvider({ children }) {
  const { user } = useAuth();
  const [unidades, setUnidades] = useState(UNIDADES_FALLBACK);
  const [unidade, setUnidadeRaw] = useState(() => localStorage.getItem(STORAGE_KEY) || "km117");

  // Bootstrap list of units
  useEffect(() => {
    if (!user) return;
    api.get("/unidades").then(({ data }) => {
      if (Array.isArray(data) && data.length) setUnidades(data);
    }).catch(() => {});
  }, [user]);

  // Persist + propagate to axios via header
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, unidade);
    api.defaults.headers.common["X-Unidade"] = unidade;
  }, [unidade]);

  const setUnidade = (id) => {
    setUnidadeRaw(id);
    // small delay to allow consumers to refetch
    window.dispatchEvent(new CustomEvent("unidade-changed", { detail: { id } }));
  };

  const value = useMemo(() => {
    const current = unidades.find((u) => u.id === unidade);
    const isAdmin = user?.role === "admin";
    return {
      unidade,
      setUnidade,
      unidades,
      isAll: unidade === "all",
      currentLabel: unidade === "all" ? "Todas as Unidades" : (current?.nome || unidade),
      isAdmin,
    };
  }, [unidade, unidades, user]);

  return <UnidadeContext.Provider value={value}>{children}</UnidadeContext.Provider>;
}

export function useUnidade() {
  const ctx = useContext(UnidadeContext);
  if (!ctx) throw new Error("useUnidade must be inside UnidadeProvider");
  return ctx;
}
